export enum AttributeCategory {
    Personality = 1,
    Skills = 2,
    Potential = 3,
    LabourMarket = 4,
} 